module.exports = __webpack_public_path__ + "img/inAppPayment.0ec7e113.webp";